
import { Button } from "@/components/ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Checkbox } from "@/components/ui/checkbox";
import { Plus } from "lucide-react";
import { SimpleTag } from "../types/categoryRules";
import { cn } from "@/lib/utils";

interface TagSelectorProps {
  tags: SimpleTag[];
  selectedTagIds: string[];
  onToggleTag: (tagId: string) => void;
  isOpen: boolean;
  onToggle: () => void;
  className?: string;
}

export const TagSelector = ({ 
  tags, 
  selectedTagIds, 
  onToggleTag, 
  isOpen, 
  onToggle,
  className 
}: TagSelectorProps) => {
  const availableTags = tags.filter(tag => !selectedTagIds.includes(tag.id));

  if (availableTags.length === 0) {
    return null;
  }

  return (
    <Popover open={isOpen} onOpenChange={onToggle}>
      <PopoverTrigger asChild>
        <Button
          variant="outline"
          size="sm"
          className={cn(
            "h-7 w-7 p-0 text-blue-600 border-blue-200 hover:bg-blue-50",
            className
          )}
        >
          <Plus className="w-3 h-3" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-64 p-3" align="start">
        <div className="space-y-2">
          <div className="text-sm font-medium text-gray-700">Select tags</div>
          <div className="max-h-40 overflow-y-auto space-y-2">
            {availableTags.map((tag) => (
              <div key={tag.id} className="flex items-center space-x-2">
                <Checkbox
                  id={`tag-${tag.id}`}
                  checked={false}
                  onCheckedChange={() => onToggleTag(tag.id)}
                />
                <label
                  htmlFor={`tag-${tag.id}`}
                  className="text-sm text-gray-700 cursor-pointer flex-1"
                >
                  {tag.name}
                </label>
              </div>
            ))}
          </div>
        </div>
      </PopoverContent>
    </Popover>
  );
};
